import { useQuery } from '@tanstack/react-query';

import { Config } from '../types/commons';
import { get } from '../api/requester';
import { getCurrentCountry } from '../utils/country';
import moment from '../utils/moment';

// We put the current country in the key because the result from the back is not the same based on the country so we
// need to create a new cache entry for each query
export const useGetConfigQuery = () => {
  const {
    data: config,
    error: configError,
    isLoading: isLoadingConfig,
  } = useQuery<Config, Error>({
    queryKey: ['config', getCurrentCountry()],
    queryFn: () => get('/config'),
    staleTime: Infinity,
    cacheTime: Infinity,
    // refetchInterval refetches data only when the app is in foreground.
    // By setting the cacheTime to Infinity, we avoid empty cache
    // when the app is back in foreground after more than a day (and when data is being refetched).
    refetchInterval: moment.duration(1, 'day').asMilliseconds(),
  });
  return { config, configError, isLoadingConfig };
};
